import { useCallback, useEffect, useState } from "react";
import api from "api";
import { exportData, formErrorStrfromObj } from "utils/shared";

import { useDispatch } from "react-redux";
import {
  setOpenDialog,
  setLoading,
  setDialogMessage,
  setDialogTitle,
  setDialog,
} from "slices/appSlice";

export const usePoliciesForReview = (hpKey) => {
  const dispatch = useDispatch();

  const [policiesForReview, setPoliciesForReview] = useState([]);

  const fetchPoliciesForReview = useCallback(
    async (hpKey) => {
      try {
        dispatch(setLoading(true));

        const response = await api.policyAdoption.policiesForReview(hpKey);
        dispatch(setLoading(false));

        if (response.status === 200 && response.data && response.data.listDto) {
          setPoliciesForReview(response.data.listDto);
        } else {
          if (response.errors) {
            dispatch(setDialogMessage(response.errors[0]));
            dispatch(setDialogTitle("Error"));
          } else {
            dispatch(
              setDialogMessage("Policy does not exist for this health plan")
            );
            dispatch(setDialogTitle("Info"));
          }
          dispatch(setOpenDialog(true));
        }
      } catch (e) {
        dispatch(
          setDialog({ message: formErrorStrfromObj(e), title: "Error" })
        );
      } finally {
        dispatch(setLoading(false));
      }
    },
    [dispatch]
  );

  useEffect(() => {
    if (hpKey) fetchPoliciesForReview(hpKey);
  }, [hpKey, fetchPoliciesForReview]);
  return [fetchPoliciesForReview, policiesForReview, setPoliciesForReview];
};

export const useUpdatePoliciesForReview = (hpKey) => {
  const dispatch = useDispatch();

  const updatePoliciesForReview = async (updatedPolicy) => {
    try {
      dispatch(setLoading(true));

      const response = await api.policyAdoption.updatePoliciesForReview(
        hpKey,
        updatedPolicy
      );
      if (response.status === 200) {
        dispatch(setDialogMessage("Record saved successfully."));
        dispatch(setDialogTitle("Success"));
        dispatch(setOpenDialog(true));
        dispatch(setLoading(false));
      } else {
        dispatch(setDialogMessage(response.errors[0]));
        dispatch(setDialogTitle("Error"));
        dispatch(setOpenDialog(true));
      }
      dispatch(setLoading(false));
    } catch (e) {
      dispatch(setDialog({ message: formErrorStrfromObj(e), title: "Error" }));
    } finally {
      dispatch(setLoading(false));
    }
  };

  return [updatePoliciesForReview];
};

export const useExportAdoptionHistory = (healthPlanKey) => {
  const dispatch = useDispatch();

  const exportAdoptionHistory = async () => {
    try {
      dispatch(setLoading(true));

      const response =
        await api.healthplanpolicies.exportAdoptionHistory(healthPlanKey);
      if (response.status === 200) {
        exportData(response.data);
      } else {
        dispatch(setDialogMessage(response.errors[0]));
        dispatch(setDialogTitle("Error"));
        dispatch(setOpenDialog(true));
      }
      dispatch(setLoading(false));
    } catch (e) {
      dispatch(setDialog({ message: formErrorStrfromObj(e), title: "Error" }));
    } finally {
      dispatch(setLoading(false));
    }
  };

  return [exportAdoptionHistory];
};

export const useImportVariance = () => {
  const dispatch = useDispatch();

  const importVariance = async (hpKey, formData, onSuccess = () => {}) => {
    dispatch(setLoading(true));

    try {
      const response = await api.policyAdoption.importVariance(hpKey, formData);

      if (response.status === 200) {
        dispatch(setDialogMessage("Data Uploaded Successfully"));
        dispatch(setDialogTitle("Success"));
        dispatch(setOpenDialog(true));
        if (typeof onSuccess === "function") {
          onSuccess(); // ✅ Ensure it's a function before calling
        }
      }
    } catch (e) {
      dispatch(setDialog({ message: formErrorStrfromObj(e), title: "Error" }));
    } finally {
      dispatch(setLoading(false));
    }
  };
  return [importVariance];
};
export const useImportAdoptionDecisions = () => {
  const dispatch = useDispatch();

  const importAdoptionDecisions = async (
    hpKey,
    formData,
    onSuccess = () => {},
    setError = () => {}
  ) => {
    dispatch(setLoading(true));
    try {
      const response = await api.policyAdoption.importAdoptionDecisions(
        hpKey,
        formData
      );

      if (response.status === 200) {
        dispatch(
          setDialog({
            message: "Data Uploaded Successfully",
            title: "Success",
          })
        );
        onSuccess(); // Trigger success callback
      }
    } catch (error) {
      setError(formErrorStrfromObj(error));
    } finally {
      dispatch(setLoading(false));
    }
  };

  return [importAdoptionDecisions];
};
